import { render, staticRenderFns } from "./WaybillDetailNew.vue?vue&type=template&id=58f66892&"
import script from "./WaybillDetailNew.vue?vue&type=script&lang=js&"
export * from "./WaybillDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./WaybillDetailNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports